import Phaser from 'phaser';
import { GameController } from './controllers/game-controller';
import { GameServices } from './game-services';
import { SolitaireListener } from './solitaire-listener';

export class SolitaireApp {
  private static instance: SolitaireApp;

  static getInstance(): SolitaireApp {
    if (!SolitaireApp.instance) {
      SolitaireApp.instance = new SolitaireApp();
    }
    return SolitaireApp.instance;
  }

  public readonly gameController: GameController;

  private readonly gameServices: GameServices;

  private constructor() {
    this.gameServices = new GameServices();
    this.gameController = new GameController(this.gameServices);
  }

  public setSolitaireListener(solitaireListener: SolitaireListener) {
    this.gameServices.setSolitaireListener(solitaireListener);
  }

  public preloadAssets(scene: Phaser.Scene, localAssetPath: string): void {
    this.gameServices.assetCatalogueService.preloadCatalogue(scene, localAssetPath);
  }
}
